import { gql } from '@apollo/client';

export const mandant = gql`
  query mandant($mandantId: ID!) {
    mandant(mandantId: $mandantId) {
      _id
      canReceivePayments
      name
      registerId
      registrationEnabled
      canReceivePayments
    }
  }
`;

export const mandants = gql`
  query mandants($onlyAdmin: Boolean) {
    mandants(onlyAdmin: $onlyAdmin) {
      _id
      name
      canReceivePayments
    }
  }
`;

export const mandantPictures = gql`
  query mandantPictures($mandantId: ID!) {
    mandantPictures(mandantId: $mandantId) {
      _id
      name
      url
      thumbUrl
    }
  }
`;

export const createAndInviteUserMut = gql`
  mutation createAndInviteUser(
    $mandantId: ID!
    $email: String!
    $firstName: String!
    $lastName: String!
  ) {
    createAndInviteUser(
      mandantId: $mandantId
      email: $email
      firstName: $firstName
      lastName: $lastName
    )
  }
`;

export const registerMandantV2Mut = gql`
    mutation registerMandantV2(
        $mandantName: String!
        $email: String!
        $firstName: String!
        $lastName: String!
        $password: String!
        $passwordConfirmation: String!
        $agbAccepted: Boolean!
    ) {
        registerMandantV2(
            mandantName: $mandantName
            email: $email
            firstName: $firstName
            lastName: $lastName
            password: $password
            passwordConfirmation: $passwordConfirmation
            agbAccepted: $agbAccepted
        ) {
            success
        }
    }
`;

export const registerAtMandantV2Mut = gql`
    mutation registerAtMandantV2(
        $registerId: ID!
        $email: String!
        $firstName: String!
        $lastName: String!
        $mobile: String
        $street: String
        $streetNr: String
        $zipCode: String
        $city: String
        $country: String
        $password: String!
        $passwordConfirmation: String!
        $agbAccepted: Boolean!
    ) {
        registerAtMandantV2(
            registerId: $registerId
            email: $email
            firstName: $firstName
            lastName: $lastName
            mobile: $mobile
            street: $street
            streetNr: $streetNr
            zipCode: $zipCode
            city: $city
            country: $country
            password: $password
            passwordConfirmation: $passwordConfirmation
            agbAccepted: $agbAccepted
        ) {
            success
        }
    }
`;

export const registerAtAnotherMandantMut = gql`
    mutation registerAtAnotherMandant(
        $registerId: ID!
        $mobile: String
    ) {
        registerAtAnotherMandant(
            registerId: $registerId
            mobile: $mobile
        )
    }
`;
